import React from "react";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";

/**
 * Quick Actions.
 *
 * This was a native <select>, which meant the open list was drawn by the
 * operating system: the highlight was the OS blue and no CSS could change it,
 * and the panel could not carry the app's rounding, spacing or shadow. An
 * antd Dropdown, the same component the transaction Sort menu uses, puts
 * the list back under our own styling, so hovering an item reads in the same
 * light green as the sidebar.
 */
const QUICK_ACTIONS = [
  { label: "New Transfer", path: "/new-transfer" },
  { label: "New Beneficiary", path: "/add-recipient" },
  { label: "Add Funds", path: "/add-funds" },
  { label: "Convert/Swap", path: "/convert" },
  { label: "Bank Account", path: "/my-account" },
  { label: "Card Setting", path: "/card" },
  { label: "View Reports", path: "/reports" },
];

// The <select> this replaced defaulted to 173px wide. Keeping that default
// means the control occupies exactly the same space as before, so converting
// it to a dropdown does not shift the navbar around it.
const QuickActionSelect = ({ className = "", selectStyle = { width: "173px" } }) => {
  const navigate = useNavigate();

  const menu = {
    items: QUICK_ACTIONS.map((action) => ({
      key: action.path,
      label: action.label,
    })),
    onClick: ({ key }) => navigate(key),
  };

  return (
    <Dropdown
      menu={menu}
      trigger={["click"]}
      placement="bottomLeft"
      overlayClassName="quick-action-menu"
    >
      <button
        type="button"
        // Keeps the class the rest of the stylesheet already targets, so the
        // dark pill styling carries over unchanged.
        className={`quick-action-select ${className}`}
        style={selectStyle}
        aria-haspopup="menu"
      >
        <span>Quick Actions</span>
        <FiChevronDown size={16} aria-hidden="true" />
      </button>
    </Dropdown>
  );
};

export default QuickActionSelect;
